import { BREAKPOINT_S } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';
import { customBreakPoint } from '~/styles/break-points';

export const PriceSectionStyle = styled.div`
	display: flex;
	flex-direction: column;

	.price {
		text-align: left;
	}

	${customBreakPoint(
		BREAKPOINT_S,
		`
			flex-direction: row;
			justify-content: space-between;

			.price {
				text-align: right;
		`,
	)}
`;
